svg4everybody();

(function() {
    $('.js-trigger').on('click', function () {
        var _trigger = $(this);
    
        var _results = $(this).siblings('.js-results');
    
        _trigger.parent().toggleClass('open');
    
        _results.stop().slideToggle('fast');
    
        $('.js-trigger').not(_trigger).parent().removeClass('open');
        $('.js-results').not(_results).slideUp('fast');
        return false;
    });
    
    $('.burger').on('click', function () {
        $(this).toggleClass('open', true);
        $(this).parents('.header').siblings('.responsive-menu').toggleClass('open', true);
        $('body').toggleClass('noscroll', true);
        return false;
    });

    $('.responsive-menu__close').on('click', function () {
        $(this).parents('.responsive-menu').toggleClass('open', false);
        $(this).parents('.responsive-menu').siblings('.header').find('.burger').toggleClass('open', false);
        $('body').toggleClass('noscroll', false);
        return false;
    });

})();